<permission-checker [roles]="roles" (contentInit)="initContent()">
  <div class="content-holder">
    <contest-select-panel [competitionId]="competitionId"
                          [contest]="contest"
                          [mobileView]="mobileView"
                          [showDetails]="false"
                          (selected)="contestSelected($event)"></contest-select-panel>

    <mat-accordion *ngIf="user" class="filters-panel">
      <mat-expansion-panel [expanded]="!region || (!school && region.id != '-1')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <ng-container *ngIf="region">{{region.name}}</ng-container>
            <ng-container *ngIf="!region"
                          i18n="User Profile|School region select input label@@user-profile-school-region-select-input-label"
            >Select Region</ng-container>
          </mat-panel-title>
          <mat-panel-description>
            <ng-container *ngIf="school">{{school.short_name || school.name}}</ng-container>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <school-select
          [roles]="roles"
          [showGrade]="false"
          [showGradeType]="false"
          [allowGradeSelect]="false"
          [selectedRegion]="region"
          [allowRegionSelect]="true"
          [addAllRegionsOption]="true"
          [allowSchoolSelect]="true"
          [showSchool]="true"
          [selectedSchoolType]="schoolType"
          [selectedSchool]="school"
          [clearSchoolAfterSelect]="false"
          [allowSchoolClear]="true"
          [schoolRequired]="false"
          (regionSelected)="regionSelected($event)"
          (schoolSelected)="schoolSelected($event.school, $event.region)"></school-select>
      </mat-expansion-panel>
    </mat-accordion>

    <app-no-content *ngIf="!inProgress && !contest"
                    [compact]="true"
                    title="Please select a contest from the list first"
                    i18n-title="Stats Dashboard|Select contest prompt@@stats-dashboard-select-contest-prompt"
                    details="Stats will be loaded for the selected region and contest"
                    i18n-details="Stats Dashboard|Select contest prompt detail@@stats-dashboard-select-contest-prompt-detail">
    </app-no-content>

    <teacher-info-table [mobileView]="mobileView"
                        [competitionId]="competitionId"
                        [contest]="contest"
                        [inProgress]="inProgress"
                        [regions]="regions"
                        [teacherStats]="teacherStats"></teacher-info-table>

    <mat-spinner *ngIf="inProgress" color="primary" diameter="30" class="center progress"></mat-spinner>

    <div *ngIf="page && page.next_token" class="center-align load-more-holder">
      <app-link class="load-more-link"
                icon="arrow_downward"
                label="load more"
                i18n-label="Students List|Load More link label@@students-list-load-more-link-label"
                (click)="loadNextPage()"></app-link>
    </div>

    <div *ngIf="contest"
         class="calculation-info text-secondary-color mat-small"
         i18n="Teacher Stats|Points calculation info@@teacher-stats-points-calculation-info"
    >Points are calculated using the following formula: 2 points per enrolled user + points for contest results (1 per average, 2
      per good, or 3 per excellent results).
    </div>
  </div>
</permission-checker>
